import { useState, useEffect } from "react"
import { Sidebar } from "../components/ui/sidebar"
import { NotificationsHeader } from "../components/ui/notifications/notifications-header"
import { NotificationsFilter } from "../components/ui/notifications/notifications-filter"
import { NotificationsList } from "../components/ui/notifications/notifications-list"
import { UniversalSearch } from "../components/ui/universal-search"
import { defaultNotifications } from "../lib/notifications-data"
import ProtectedRoute from "../components/ProtectedRoute"
import api from "@/hooks/api/apiClient"
import config from "../../config"

const NotificationsPage = () => {
  const [notifications, setNotifications] = useState(defaultNotifications)
  const [activeFilter, setActiveFilter] = useState("all")

  useEffect(() => {
    if (config.appMode === "prototype") return;
    api.get("/notifications")
      .then((res) => {
        const items = res.data?.data?.notifications ?? [];
        if (items.length > 0) {
          setNotifications(items.map((n) => ({
            id: n._id ?? n.id,
            title: n.title,
            message: n.message,
            type: n.category ?? n.type ?? "general",
            time: new Date(n.createdAt ?? Date.now()).toLocaleDateString(),
            read: n.read ?? false,
            actionUrl: n.actionUrl,
          })));
        }
      })
      .catch(() => {});
  }, []);

  const filteredNotifications =
    activeFilter === "all" ? notifications : notifications.filter((n) => n.type === activeFilter)

  const unreadCount = notifications.filter((n) => !n.read).length

  const handleMarkAsRead = (id) => {
    setNotifications((prev) => prev.map((n) => (n.id === id ? { ...n, read: true } : n)))
    if (config.appMode !== "prototype") api.patch(`/notifications/${id}/read`, {}).catch(() => {});
  }

  const handleMarkAllAsRead = () => {
    setNotifications((prev) => prev.map((n) => ({ ...n, read: true })))
    if (config.appMode !== "prototype") api.patch("/notifications/read-all", {}).catch(() => {});
  }

  const handleActionClick = (notification) => {
    if (notification.action) notification.action.onClick()
  }

  const handleSearch = (query) => {
    console.log("Universal search for:", query)
  }

  return (
    <ProtectedRoute>
       <div className="flex min-h-screen bg-slate-200">
      {/* Sidebar - Self-contained */}
      <Sidebar />
      
      <UniversalSearch onSearch={handleSearch} />

      {/* Main Content */}
      <main className="flex-1 lg:ml-64 p-3 sm:p-4 md:p-6 lg:p-8 overflow-y-auto w-full transition-all duration-300 ease-in-out">
        {/* Mobile Header with Menu Button */}
        <div className="md:hidden flex items-center gap-3 mb-4 pb-4 border-b border-slate-200">
          <div className="flex-1">
            <h1 className="text-lg font-bold text-slate-900">Notifications</h1>
          </div>
        </div>
        
        <div className="md:ml-0 ml-0 px-6 max-w-4xl mx-auto">
          {/* Header */}
          <NotificationsHeader unreadCount={unreadCount} onMarkAllAsRead={handleMarkAllAsRead} />

          {/* Filter Section */}
          <div className="my-6">
            <NotificationsFilter activeFilter={activeFilter} onFilterChange={setActiveFilter} />
          </div>

          {/* Notifications List */}
          <div className="mt-6">
            <NotificationsList
              notifications={filteredNotifications}
              onMarkAsRead={handleMarkAsRead}
              onActionClick={handleActionClick}
            />
          </div>
        </div>
      </main>
    </div>
    </ProtectedRoute>
  )
}

export default NotificationsPage